import React, { useState, useEffect, useRef } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import Button from '@mui/material/Button';
import { GetDashboardEmbedConfig } from '../../../api/reports';
import { useQuery } from '@tanstack/react-query';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
function PowerBiDash({ params, powerBiUpdateDetails }) {
  const REACT_APP_POWERBI_WORKSPACE_ID = process.env.REACT_APP_POWERBI_WORKSPACE_ID;
  const REACT_APP_POWERBI_DASHBOARD_ID = process.env.REACT_APP_POWERBI_DASHBOARD_ID;
  const REACT_APP_POWERBI_GROUP_ID = process.env.REACT_APP_POWERBI_GROUP_ID;
  const REACT_APP_AGENTPORTAL_PREFIX = process.env.REACT_APP_AGENTPORTAL_PREFIX;

  const missingConfig = !REACT_APP_POWERBI_WORKSPACE_ID || !REACT_APP_POWERBI_DASHBOARD_ID;

  //const parsedParams = params === "undefined" ? null : [JSON.parse(params)];
  const [paramsState, setParamsState] = useState({});
  const [updateDetails, setUpdateDetails] = useState([]);

  const handleUpdateParamsState = (key, value) => {
    let tempParamsState = paramsState;
    tempParamsState[key] = value;

    setParamsState(tempParamsState);
  };
  const handleSubmitParams = () => {
    Object.keys(paramsState).map((key, index) => {
      setUpdateDetails([...updateDetails, { name: key, newValue: paramsState[key] }]);
    });
  };

  useEffect(() => {
    if (Object.keys(paramsState).length > 0) {
      handleSubmitParams();
    }
  }, [paramsState]);

  const embedReturn = useQuery({
    queryKey: ['dashboardEmbedConfig', updateDetails],
    queryFn: () =>
      GetDashboardEmbedConfig({
        workspaceId: REACT_APP_POWERBI_WORKSPACE_ID,
        dashboardId: REACT_APP_POWERBI_DASHBOARD_ID,
        updateDetails: updateDetails,
        groupId: REACT_APP_POWERBI_GROUP_ID,
      })(),
    enabled: !missingConfig,
  });
  //console.log(parsedParams, "parsed params")
  //useEffect(() => {
  //    if (updateDetails.length > 0) {
  //        //console.log(updateDetails);
  //        embedReturn.refetch()
  //    }
  //}, [updateDetails])

  useEffect(() => {
    if (powerBiUpdateDetails) {
      setUpdateDetails(powerBiUpdateDetails);
    }
  }, [powerBiUpdateDetails]);
  //console.log(embedReturn.data, "embed return")
  //if (!parsedParams) return <></>
  //if (updateDetails.length === 0) {
  //    return <div className="container">
  //        <div className="row mt-4">
  //            {parsedParams.map((param, index) => {
  //                switch (param.ParameterType) {
  //                    case "SingleText":
  //                        return <div className="col-3 d-flex justify-content-start align-items-center">
  //                            <input onBlur={(e) => { handleUpdateParamsState(param.ParameterName, e.target.value) }} style={{ height: '2.5em' }} className="form-control form-control-sm ml-3 w-75" type="text" placeholder={param.ParameterName} aria-label="Search" />
  //                        </div>
  //                    default:
  //                        break;
  //                }
  //            })}
  //            <div className="col-1 justify-content-start align-items-center">
  //                <Button onClick={() => { handleSubmitParams(); }} variant="contained" className="btn btn-primary">View</Button>
  //            </div>
  //        </div>
  //    </div>
  //}
  //console.log(embedReturn, "embedReturn");
  if (missingConfig) return <p>There was a problem loading the Power BI dashboard</p>;
  if (!embedReturn) return <></>;
  if (embedReturn.status === 'pending')
    return (
      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center' }}>
        <LoadingIndicator size={'sm'} style={{ marginTop: 'auto', marginBottom: 'auto' }} />
      </div>
    );
  if (embedReturn.status === 'error') return <h1>{JSON.stringify(embedReturn.error)}</h1>;
  if (embedReturn.data?.error) return <p>{embedReturn.data.error}</p>;
  //console.log(powerBiUpdateDetails, "update details")
  if (embedReturn.data?.embedUrl != null && embedReturn.data?.embedToken?.token != null) {
    return (
      <>
        <PowerBIEmbed
          embedConfig={{
            //make type dynamic to support dashboards & reports?? - would need to make id, embedUrl, etc. dynamic as well

            type: 'dashboard', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
            id: embedReturn.data?.id,
            embedUrl: embedReturn?.data?.embedUrl,
            accessToken: embedReturn?.data?.embedToken.token,
            tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
            settings: {
              filterPaneEnabled: true,
              navContentPaneEnabled: true,
              background: models.BackgroundType.Transparent,
              // START Report specific settings                            layoutType: models.LayoutType.Custom,
              customLayout: {
                displayOption: models.DisplayOption.FitToWidth,
              },
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
              },
            },
          }}
          eventHandlers={
            new Map([
              [
                'loaded',
                function () {
                  console.log('Report loaded');
                },
              ],
              [
                'rendered',
                function () {
                  console.log('Report rendered');
                },
              ],
              [
                'error',
                function (event) {
                  console.log(event.detail);
                },
              ],
            ])
          }
          cssClassName={'EmbedDashboard-Container'}
          getEmbeddedComponent={(embeddedReport) => {
            window.report = embeddedReport;
          }}
        />
      </>
    );
  } else {
    return <></>;
  }
}

export default PowerBiDash;
